export default __webpack_public_path__ + "static/media/new-relic-logo.2601d286.webp";